<template>
    <div class="device_l">
      <div class="device-page">
          <div class="container">
            <div class="chart-block">
                <div class="item">
                <img src="../assets/img/sjtj-title.png" alt="">
                <div class="chart-box">
                    <v-chart :options="options_sjtj" />
                </div>
                </div>
                <div class="item">
               <img src="../assets/img/gzhz-title.png" alt="">
                <div class="chart-box">
                    <v-chart :options="options_gzhz" />
                </div>
                </div>
                <div class="item">
                 <img src="../assets/img/sjhz-title.png" alt="">
                <div class="chart-box">
                    <v-chart :options="options_gzsjhz" />
                </div>
                </div>
                <div class="item">
                  <img src="../assets/img/sbfh-title.png" alt="">
                </div>
            </div>
          </div>
      </div>
  </div>

   
</template>

<script>
import echarts from 'echarts/lib/echarts'
import DatePicker from 'vue2-datepicker'
import pagination from '@/components/widgets/Pagination'
export default{
  components: {
    DatePicker,
    'v-pagination': pagination,
  },
  props: ['theme'],
  data() {
    let tabData = ['故障清单', '保养清单'];
    let todayTime = (new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / 1000;  //今天0点时间戳秒
    return {
      sjtjList: [],
      options_sjtj: {},
      gzhzList: [],
      options_gzhz: {},
      gzsjhzList: [],
      options_gzsjhz: {},
      StartDate: this.$formatDateTime(todayTime - 3600*24*30, 'yyyy-MM-dd'),
      EndDate: this.$formatDateTime(null, 'yyyy-MM-dd'),

      itemList: [],
      tabData: tabData,

      tabKey: "故障清单",//tabData[0]
      popped: false,
      totalCount: 0,
      pageIndex: 1,
      pageSize: 5,
      StartDate1: '',
      EndDate1: this.$formatDateTime(null, 'yyyy-MM-dd'),
    }
  },
  watch: {
    popped(val) {
      if(!val) {
        this.pageSize = 5;
      } else {
        this.pageSize = 5*2+1;
      }
      this.pageChange(1);
    },
  },
  mounted() {
    this.resetData1();
      //定义全局方法
    window.gbfc_resetData1 = this.resetData1;
    window.gbfc_popupWindow = this.popupWindow;
    /*
    //设备负荷
    //this.getSbfhList();*/
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData1() {
      this.tabKey = '故障清单'
      this.getItemList();
    },
    popupWindow(val) {
      this.popped = val;
    },
    tabSwitch(item) {
      this.tabKey = item;
      this.getItemList();
    },
    getItemList() {
      let self = this;
      let url = '';
      this.itemList = [];

      if(this.tabKey == '故障清单') {
        url = window.ApiHost1+'/api/DataStatistical/Equip_BreakDown_Info';
        //url = window.ApiHost1+'/static/data/Equip_BreakDown_Info.json';
      } else {
        url = window.ApiHost1+'/api/DataStatistical/Equip_Maintenance_Info';
        //url = window.ApiHost1+'/static/data/Equip_Maintenance_Info.json';
      }
      this.$handleRequest(url, {
        "PageIndex": this.pageIndex,
        "PageSize": this.pageSize,
        "EquipmentCode": "",
        "StartDate": "2019-04-08",
        "EndDate": "2019-09-08",
        "WareHouseCode": window.PYKWareHouseCode,
      }, 'post', function(res) {  //success
        self.itemList = res.retData.Rows;
        self.totalCount = res.retData.TotalCount;
      }, function(res) {
            console.log(res)
        //fail
      });
    },
    pageChange(pageIndex) {
      console.log('pageIndex', pageIndex);
      this.pageIndex = pageIndex;
      this.getItemList();
    },
    resetData() {
      if(window.setDate) {
        window.setDate(JSON.stringify({StartDate: this.StartDate, EndDate: this.EndDate}));
      }
      //时间统计
      this.getSjtjList();
      //故障次数汇总
      this.getGzhzList();
      //故障时间汇总
      this.getGzsjhzList();
    },
    searchData() {
      this.resetData();
    },
    getSjtjList() {
      let self = this;
      let totalData = [];
      let recentData = [];
      this.$handleRequest(window.ApiHost2+'/InteractAPI/CalcuTotalDuration_FieldStutas/'+window.PYKScadaCode1+'/自动/-1', {}, 'get', function(res) {  //success
        totalData = res;
        self.$handleRequest(window.ApiHost2+'/InteractAPI/CalcuTotalDuration_FieldStutas/'+window.PYKScadaCode1+'/自动/1', {}, 'get', function(res) {  //success
          recentData = res;
          console.log('--recentData--', res, totalData, recentData);
          totalData.forEach( function(t, ti) {
            recentData.forEach( function(r, ri) {
              if(t.Field == r.Field) {
                let tmp = {
                  field: t.Field,
                  lists: [
                    {
                      label: '历史运行总时长',
                      count: t.TotalDuration
                    },
                    {
                      label: '最近一次运行总时长',
                      count: r.TotalDuration
                    },
                  ]
                };
                self.sjtjList.push(tmp);
              }
            });
          });
          self.setOptionsSjtj();
        }, function(res) {
          //fail
        });
      }, function(res) {
        //fail
      });
    },
    //时间统计
    setOptionsSjtj() {
      let self = this;
      let colors = this.$charts.colors.style_14;
      let chartsConf = this.$charts[window.CurrentTheme];
      let legendData = [];
      let xdata = [];
      let sdata = [];

      this.sjtjList.forEach( function(d, di) {
        d.lists.forEach( function(t, ti) {
          if(legendData.indexOf(t.label) == -1) {
            legendData.push(t.label);
          }
          if(di == 0) {  //
            let tmpdata = [];
            self.sjtjList.forEach( function(dd) {
              dd.lists.forEach( function(tt) {
                if(tt.label == t.label) {
                  tmpdata.push(tt.count)
                }
              })
            });
            let stack = '';
            let markPoint = {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
            }
            let tmp = {
              name: t.label,
              type:'bar',
              barWidth: 15,//柱图宽度
              barGap: '50%',
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {offset: 0, color: colors[ti][0]}, {offset: 1, color: colors[ti][1]}
              ]),
              stack: stack,
              markPoint: markPoint,
              data: tmpdata
            }
            sdata.push(tmp)
          }
        });
        xdata.push(d.field);
      });

      this.options_sjtj = {
        // center : ['55%', '50%'],
        tooltip: {
          trigger: 'axis',
          axisPointer : {
            type : 'shadow'
          },
          textStyle: {
            fontSize: 14,
          }
        },
        legend: {
          //right: 100,
          textStyle: {
            color: '#000',
            fontSize: 14
          },
          data: legendData
        },
        xAxis: [
          {
            type: 'category',
            nameRotate: 180,
            axisLabel: {
              //rotate: -25,
              color: '#000',
              fontSize: 14
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: 'chartsConf.xAxis.color_1',
                width: 1, //这里是为了突出显示加上的
              }
            },
            data : xdata
          }
        ],
        yAxis: [
          {
            name: '运行时长(h)',
            type: 'value',
            nameTextStyle: {
              color: '#000',
              fontSize: 14
            },
            axisLabel: {
              color: '#000',
              fontSize: 14,
              formatter: function(val, index) {
                if(val >= 1000) {
                  val = val/1000 + 'k';
                }else if(val < 1000) {
                  val = val;
                }
                return val;
              }
            },
            axisLine:{  //设置轴线的属性
              lineStyle: {
                color: chartsConf.yAxis.color_1,
                width: 1, //这里是为了突出显示加上的
              }
            },
            splitLine: {
              show: true,
              lineStyle:{
                color: [chartsConf.yAxis.color_2],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        series : sdata
      };
    },
    getGzhzList() {
      let self = this;
      let todayTime = (new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / 1000;  //今天0点时间戳毫秒
      let startTime = this.$formatDateTime(todayTime - 3600*24, 'yyyy-MM-dd hh:mm:ss');
      let endTime = this.$formatDateTime(todayTime, 'yyyy-MM-dd hh:mm:ss');

      if(this.tabKey == '日') {
        //
      } else if(this.tabKey == '周') {
        startTime = this.$formatDateTime(todayTime - 3600*24*7, 'yyyy-MM-dd hh:mm:ss');
      } else if(this.tabKey == '月') {
        startTime = this.$formatDateTime(todayTime - 3600*24*30, 'yyyy-MM-dd hh:mm:ss');
      }
      console.log('--', startTime, endTime)
      let url = '/InteractAPI/FailureDistribution_Stn_Times/'+this.StartDate+'/'+this.EndDate;
      this.$handleRequest(window.ApiHost2+url, {}, 'get', function(res) {  //success
        if(res.length > 0) {
          self.gzhzList = res;
        } else {
          self.gzhzList = [{"StationName":"无数据", "TotalTime_Stn": 0}];
        }        
        self.setOptionsGzhz();
      }, function(res) {  //fail
        console.log('fail', res);
      });
    },
    setOptionsGzhz() {
      let colors = this.$charts.colors.style_2;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let legendData = [];

      this.gzhzList.forEach( function(l, li) {
        legendData.push(l.StationName);
        let color = colors[li][1];
        let tmp = {
          value: l.TotalTime_Stn,
          name: l.StationName,
          label: {
            color: '#000',
            fontSize: 24
          },
          itemStyle:{
            normal:{
              color: color,
            }
          }
        };
        sdata.push(tmp);
      });
      this.options_gzhz = {
        tooltip : {
            trigger: 'item',
            formatter: "{b} : {c}次 ({d}%)",
            textStyle: {
              fontSize: 24
            }
        },
        girld:{
          left:'3%',
          top:'80%',

        },
        legend: {
            x : 'center',
            y : 'bottom',
            type: 'scroll',
            textStyle: {
              color: chartsConf.legend.color,
              fontSize: 24
            },
            data: legendData
        },
        //calculable : true,
        series : [
            {
              type:'pie',
              radius: ['24%', '40%'],
              center : ['55%', '45%'],
              //roseType : 'area',
              data: sdata
            }
        ]
      };
    },
    getGzsjhzList() {
      let self = this;
      let todayTime = (new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / 1000;  //今天0点时间戳毫秒
      let startTime = this.$formatDateTime(todayTime - 3600*24, 'yyyy-MM-dd hh:mm:ss');
      let endTime = this.$formatDateTime(todayTime, 'yyyy-MM-dd hh:mm:ss');

      if(this.tabKey == '日') {
        //
      } else if(this.tabKey == '周') {
        startTime = this.$formatDateTime(todayTime - 3600*24*7, 'yyyy-MM-dd hh:mm:ss');
      } else if(this.tabKey == '月') {
        startTime = this.$formatDateTime(todayTime - 3600*24*30, 'yyyy-MM-dd hh:mm:ss');
      }
      let url = '/InteractAPI/Distribution_AE_Stn_Duration/'+window.PYKScadaCode+'/'+this.StartDate+'/'+this.EndDate+'/0';
      this.$handleRequest(window.ApiHost2+url, {}, 'get', function(res) {  //success
        if(res.length > 0) {
          self.gzsjhzList = res;
        } else {
          self.gzsjhzList = [{"StationName":"无数据", "TotalDuration_Stn":0}];
        }
        
        self.setOptionsGzsjhz();
      }, function(res) {  //fail
        console.log('fail', res);
      });
    },
    setOptionsGzsjhz() {
      let colors = this.$charts.colors.style_2;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let legendData = [];

      this.gzsjhzList.forEach( function(l, li) {
        legendData.push(l.StationName);
        let value = Math.round(l.TotalDuration_Stn/60*100)/100;
        let color = colors[li][1];
        let tmp = {
          value: value,
          name: l.StationName,
          label: {
            color: '#000',
            fontSize: 14
          },
          itemStyle:{
            normal:{
              color: color,
            }
          }
        };
        sdata.push(tmp);
      });
      this.options_gzsjhz = {
        tooltip : {
            trigger: 'item',
            formatter: "{b} : {c}min ({d}%)",
            textStyle: {
              fontSize: 14
            }
        },
        legend: {
            x : 'center',
            y : 'bottom',
            type: 'scroll',
            textStyle: {
              color: '#000',
              fontSize: 14
            },
            data: legendData
        },
        //calculable : true,
        series : [
            {
              type:'pie',
              radius: ['24%', '40%'],
              center : ['45%', '45%'],
              //roseType : 'area',
              data: sdata
            }
        ]
      };
    },
  }
}
</script>

<style scoped>
.device_l{
  width:100%;
}
.item:first-child{
  border-right: 1px solid #CAE8FF;
  border-bottom: 1px solid #CAE8FF;
  box-sizing: border-box;
}
.item:nth-child(2){
  border-bottom: 1px solid #CAE8FF;
  box-sizing: border-box;
}
.item:nth-child(3){
  border-right: 1px solid #CAE8FF;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/xiayan/device/DeviceTotal.vue